/**
 * Created by claudio iozzia on 10/07/2017.
 */
import {AcceptorFn} from "../../../../models/acceptor/IAcceptor";
import {Ic} from "../../../../models/common";
import {IAppSpec} from "../../../../Redux/selector.state";
import {NumLEDBounds} from "../../acdc/NumLEDBounds";

export const dcLED_NumLED_acceptor: AcceptorFn = (ic: Ic, spec: IAppSpec): boolean => {
  const upperBound: NumLEDBounds = NumLEDBounds.getIt(ic);
  const ret = spec.spec.value.output.ledParam.serial <= upperBound.series
    && spec.spec.value.output.ledParam.parallel <= upperBound.parallel;
  // console.log("dcLED_NumLED_acceptor", ic, ret);
  return ret;

};

